import * as ReactRedux from 'react-redux'

import * as Configuration from './configuration'

export function useBrand() {
  return ReactRedux.useSelector(state =>
    Configuration.getBrand(state.configuration)
  )
}
